import { number } from 'yup'

export default number().required().moreThan(1).positive()
